import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { FabricatorRewardsComponent } from './fabricator-rewards.component';

const routes: Routes = [{ path: '', component: FabricatorRewardsComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class FabricatorRewardsRoutingModule { }
